import { Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import * as yup from "yup";
import { Button } from "../../../components/ui/button";
import Card from "../../../components/ui/card-snippet";
import { useLocation, useNavigate } from "react-router-dom";
import {
  PromoCodeDiscountTypeEnum,
  respEnum,
  IntMax,
  DateminFormat,
  IntMin,
  IntCourtPriceMin,
  IntMinLevel,
  RoleEnum,
  DateTimeminFormat,
  ToCSharpFormat,
} from "../../../constants/appConstant";
import {
  FormikInput,
  FormikSwitch,
  FormikSearchSelect,
  FormikDate,
  FormikSelect,
} from "../../../components/formik-components";
import Common from "../../../helper/common";
import { useQueryParams } from "../../../contexts/queryParamsContext";

const twoDecimalRegex = /^\d{1,2}(\.\d{1,2})?$/;
const formValidations = yup.object({
  // name: yup.string().required("Name is required"),
  discountType: yup.number().required("Discount Type is required"),
  discountValue: yup
    .number()
    .required("Discount value is required")
    .min(IntMinLevel)
    .max(IntMax),
  // minOrderAmount: yup.number().min(IntMinLevel).max(IntMax),
  // .required("Min Order is required"),
  maxDiscount: yup
    .number()
    .min(IntMinLevel)
    .max(IntMax)
    .required("Max Discount is required"),
  bin: yup.string().required("BIN is required"),
  // .test(
  //   "is-required-if-percentage",
  //   "Max Discount is required when Discount Type is Percentage",
  //   function (value) {
  //     const { discountType } = this.parent;
  //     if (discountType === PromoCodeDiscountTypeEnum.Percentage) {
  //       return value !== undefined && value !== null && value !== "";
  //     }
  //     return true;
  //   }
  transactionallowedperday: yup.number().min(IntMinLevel).max(IntMax),
  // .required("Daily Transaction Limit is required"),
  bankid: yup.number().required("Bank is required"),
  bankcardtypeid: yup.number().required("Card Type is required"),
  bankcardcategoryid: yup.number().required("Card Category is required"),
    });

export default function AddBankDiscount() {
  const navigate = useNavigate();
  const formikRef = useRef();
  const [roleId, setRoleId] = useState(null);
  const [banks, setBanks] = useState([]);
  const [cardTypes, setCardTypes] = useState([]);
  const [cardCategories, setCardCategories] = useState([]);
  const location = useLocation();
  const { id, setId } = useQueryParams();

  useEffect(() => {
    (async () => {
      setRoleId(global.user.roleId);
    })();
  }, []);

  useEffect(() => {
    getBanks();
    getCardTypes();
    getCardCategories();
  }, []);

  useEffect(() => {
    if (id) {
      getBankDiscountDetail();
    }

    return () => {
      setId(null);
    };
  }, [id]);

  const formInitialValue = {
    validfrom: id ? DateTimeminFormat : "",
    validtill: id ? DateTimeminFormat : "",
    isactive: true,
    isdisplayonapp: false,
  };

  const getBanks = async () => {
    return new Promise(async (res) => {
      const response = await Common.ApiService.getInstance().request(
        "GetBanks",
        { isactive: true }
      );
      const data = [
        { id: null, name: "Select Bank" },
        ...(response?.data ?? []),
      ];
      setBanks(data);
      res();
    });
  };

  const getCardTypes = async () => {
    return new Promise(async (res) => {
      const response = await Common.ApiService.getInstance().request(
        "GetBankCardType",
        { isactive: true }
      );
      const data = [
        { id: null, name: "Select Card Type" },
        ...(response?.data ?? []),
      ];
      setCardTypes(data);
      res();
    });
  };

  const getCardCategories = async () => {
    return new Promise(async (res) => {
      const response = await Common.ApiService.getInstance().request(
        "GetBankCardCategories",
        { isactive: true }
      );
      const data = [
        { id: null, name: "Select Card Category" },
        ...(response?.data ?? []),
      ];
      setCardCategories(data);
      res();
    });
  };

  const getBankDiscountDetail = async () => {
    let response = await Common.ApiService.getInstance().request(
      `GetClubBankDiscountDetails?id=${id}`
    );

    if (response.status == respEnum.Success && response?.data?.length > 0) {
      let d = response?.data?.[0];
      if (formikRef.current) {
        // Format dates for datetime-local input
        if (d.validfrom) {
          d.validfrom = Common.moment(d.validfrom).format(DateTimeminFormat);
        }
        if (d.validtill) {
          d.validtill = Common.moment(d.validtill).format(DateTimeminFormat);
        }
        formikRef.current.setValues(d);
      }
    }
  };

  const onSubmitData = async (d, action) => {
    // Generate name by concatenating bank, card category, and card type names
    const selectedBank = banks.find((bank) => bank.id === +d.bankid);
    const selectedCardCategory = cardCategories.find(
      (category) => category.id === +d.bankcardcategoryid
    );
    const selectedCardType = cardTypes.find(
      (type) => type.id === +d.bankcardtypeid
    );

    const generatedName = `${selectedBank?.name || ""} ${
      selectedCardCategory?.name || ""
    } ${selectedCardType?.name || ""}`.trim();

    debugger;
    let data = {
      ...d,
      name: generatedName, // Set the concatenated name
      discountType: +d.discountType,
      minOrderAmount: d.minOrderAmount ? +d.minOrderAmount : null,
      maxDiscount: d.maxDiscount ? +d.maxDiscount : null,
      discountValue: d.discountValue ? +d.discountValue : null,
      bankid: d.bankid ? +d.bankid : null,
      bankcardtypeid: d.bankcardtypeid ? +d.bankcardtypeid : null,
      bankcardcategoryid: d.bankcardcategoryid ? +d.bankcardcategoryid : null,
      transactionallowedperday: d.transactionallowedperday
        ? +d.transactionallowedperday
        : null,
      validfrom: d.validfrom
        ? Common.moment(`${d.validfrom}`).format(ToCSharpFormat)
        : null,
      validtill: d.validtill
        ? Common.moment(`${d.validtill}`).format(ToCSharpFormat)
        : null,
      id: id ? +id : 0,
      isdisplayonapp: d.isdisplayonapp,
    };

    if (
      data.discountType == PromoCodeDiscountTypeEnum.Percentage &&
      data.discountValue > 100
    ) {
      Common.showToast("Percentage so discount value should be less than 100 ");
      return;
    }

    if (data.validfrom && data.validtill && data.validfrom > data.validtill) {
      Common.showToast("Valid Till Date must be greater than Valid From");
      return;
    }

    let response = await Common.ApiService.getInstance().request(
      "AddUpdateClubBankDiscount",
      data,
      "POST"
    );
    action.setSubmitting(false);

    if (response.status == respEnum.Success) {
      Common.SweetAlert.alert(response.message);
      setTimeout(() => {
        navigate("/app/bankdiscounts");
      }, 1000);
    }
  };

  const resetFields = (value, formikProps) => {
    if (+value == PromoCodeDiscountTypeEnum.Fixed_Amount) {
      formikProps.setFieldValue("maxDiscount", "");
    }
    if (+value == PromoCodeDiscountTypeEnum.Percentage) {
      formikProps.setFieldValue("discountValue", "");
    }
  };


  //
  /**
 * Cleans and normalizes numeric input, allowing only digits and a single decimal point
 */
  const cleanNumericInput = (value) => {
  if (!value) return "";
  
  let cleaned = String(value).replace(/[^\d.]/g, "");
  if (!cleaned) return "";
  
  // Keep only the first decimal point
  const firstDot = cleaned.indexOf(".");
  if (firstDot !== -1) {
    cleaned = cleaned.slice(0, firstDot + 1) + cleaned.slice(firstDot + 1).replace(/\./g, "");
  }
  return cleaned;
};

/**
 * Formats the percentage value with proper constraints (0-100, max 2 decimals)
 */
const formatPercentage = (cleaned) => {
  if (!cleaned || cleaned === ".") return "";
  
  const endsWithDot = cleaned.endsWith(".");
  const hadDot = cleaned.includes(".");
  
  const [intPartRaw = "", decPartRaw = ""] = cleaned.split(".", 2);
  
  // Remove leading zeros except for "0" or "100"
  let intPart = intPartRaw;
  if (intPartRaw.length > 1 && intPartRaw.startsWith("0") && intPartRaw !== "100") {
    intPart = String(parseInt(intPartRaw, 10) || 0);
  }
  
  // Limit integer part to 2 digits (or "100")
  intPart = intPartRaw === "100" ? "100" : intPart.slice(0, 2);
  
  // Limit decimal part to 2 digits
  const decPart = decPartRaw.slice(0, 2);
  
  // Build the candidate value
  let candidate = intPart;
  if (intPart === "100") {
    if (hadDot) {
      candidate = "100" + (endsWithDot ? "." : decPart ? `.${decPart}` : "");
    }
  } else if (hadDot) {
    candidate = intPart + (endsWithDot ? "." : decPart ? `.${decPart}` : ".");
  }
  
  // Enforce max value of 100
  if (candidate && !endsWithDot) {
    const numericCheck = parseFloat(candidate);
    if (!isNaN(numericCheck) && numericCheck > 100) {
      return "100";
    }
  } else if (candidate) {
    const numericCheck = parseFloat(candidate.slice(0, -1));
    if (!isNaN(numericCheck) && numericCheck > 100) {
      return "100.";
    }
  }
  
  return candidate;
};

/**
 * Calculates the complementary percentage (100 - value)
 */
const calculateComplement = (value) => {
  if (!value || value.endsWith(".")) return null;
  
  const num = parseFloat(value);
  if (isNaN(num)) return null;
  
  return parseFloat((100 - num).toFixed(2));
};

/**
 * Normalizes value on blur (removes trailing dot, formats to 2 decimals)
 */
const normalizeOnBlur = (value) => {
  const cleaned = cleanNumericInput(value);
  if (!cleaned) return { normalized: null, isValid: true };
  
  const normalized = cleaned === "." ? "0" : cleaned.endsWith(".") ? cleaned.slice(0, -1) : cleaned;
  const num = parseFloat(normalized);
  
  if (isNaN(num) || num < 0 || num > 100) {
    return { normalized: null, isValid: false };
  }
  
  return { 
    normalized: num.toFixed(2), 
    isValid: true,
    complement: (100 - num).toFixed(2)
  };
};

/**
 * Handles percentage input change
 */
const handlePercentageChange = (value, formikProps, fieldName, complementFieldName) => {
  // Handle empty input
  if (!value) {
    formikProps.setFieldValue(fieldName, null);
    formikProps.setFieldValue(complementFieldName, null);
    return;
  }
  
  // Clean and format the input
  const cleaned = cleanNumericInput(value);
  if (!cleaned) {
    formikProps.setFieldValue(fieldName, "");
    return;
  }
  
  const formatted = formatPercentage(cleaned);
  formikProps.setFieldValue(fieldName, formatted);
  
  // Calculate and set complement value
  const complement = calculateComplement(formatted);
  if (complement !== null) {
    formikProps.setFieldValue(complementFieldName, complement);
  }
};

/**
 * Handles percentage input blur
 */
const handlePercentageBlur = (e, formikProps, fieldName, complementFieldName) => {
  const result = normalizeOnBlur(e.target.value);
  
  if (!result.isValid || result.normalized === null) {
    formikProps.setFieldValue(fieldName, null);
    formikProps.setFieldValue(complementFieldName, null);
    return;
  }
  
  formikProps.setFieldValue(fieldName, result.normalized);
  formikProps.setFieldValue(complementFieldName, result.complement);
};

  //

  return (
    <Formik
      initialValues={formInitialValue}
      validationSchema={formValidations}
      innerRef={formikRef}
      validateOnBlur={false}
      validateOnChange={false}
      onSubmit={onSubmitData}
    >
      {(formikProps) => {
        formikRef.current = formikProps;
        return (
          <>
            <div className="space-y-6 mb-5">
              <Card title={id ? "Edit Bank Discount" : "Create Bank Discount"}>
                <div className="md:grid md:grid-cols-10 gap-4 p-5">
                  <div className="flex flex-col col-span-2 gap-2">
                    <FormikSearchSelect
                      formikProps={formikProps}
                      name={"bankid"}
                      data={banks}
                      placeholder={"Select Bank"}
                      label={"Bank"}
                    />
                  </div>

                  <div className="flex flex-col col-span-2 gap-2">
                    <FormikSearchSelect
                      formikProps={formikProps}
                      name={"bankcardcategoryid"}
                      data={cardCategories}
                      placeholder={"Select Card Category"}
                      label={"Card Category"}
                    />
                  </div>

                  <div className="flex flex-col col-span-2 gap-2">
                    <FormikSearchSelect 
                      formikProps={formikProps}
                      name={"bankcardtypeid"}
                      data={cardTypes}
                      placeholder={"Select Card Type"}
                      label={"Card Type"}
                    />
                  </div>

                  <div className="flex flex-col col-span-2 gap-2">
                    <FormikInput
                      formikProps={formikProps}
                      name={"bin"}
                      placeholder={"BIN Number"}
                      label={"BIN"}
                      maxLength="20"
                    />
                  </div>

                  <div className="flex flex-col col-span-2 gap-2">
                    <FormikInput
                      formikProps={formikProps}
                      name={"validfrom"}
                      label={"Valid From"}
                      type={"datetime-local"}
                    />
                  </div>

                  <div className="flex flex-col col-span-2 gap-2">
                    <FormikInput
                      formikProps={formikProps}
                      name={"validtill"}
                      label={"Valid Till"}
                      type={"datetime-local"}
                    />
                  </div>

                  <div className="flex flex-col col-span-2 gap-2">
                    <FormikSearchSelect
                      formikProps={formikProps}
                      name={"discountType"}
                      data={[
                        {
                          id: PromoCodeDiscountTypeEnum.Percentage,
                          name: "Percentage",
                        },
                        {
                          id: PromoCodeDiscountTypeEnum.Fixed_Amount,
                          name: "Fixed Amount",
                        },
                      ]}
                      placeholder={"Select Type"}
                      label={"Discount Type"}
                      onChange={(e) => {
                        resetFields(e, formikProps);
                      }}
                    />
                  </div>

                  <div className="flex flex-col col-span-2 gap-2">
                    <FormikInput
                      formikProps={formikProps}
                      name={"discountValue"}
                      placeholder={"Enter Discount Value"}
                      label={"Discount Value"}
                      type={"number"}
                      max={IntMax}
                      min={IntMinLevel}
                      onChange={(value) => {
                        if (value < IntMinLevel && value != "") {
                          formikProps.setFieldValue(
                            "discountValue",
                            IntMinLevel
                          );
                        } else if (
                          formikProps.values.discountType ==
                            PromoCodeDiscountTypeEnum.Percentage &&
                          value > IntCourtPriceMin
                        ) {
                          Common.showToast(
                            `Discount value cannot be greater than ${IntCourtPriceMin}`
                          );
                          formikProps.setFieldValue("discountValue", "");
                        } else if (
                          formikProps.values.discountType !=
                            PromoCodeDiscountTypeEnum.Percentage &&
                          value > IntMax
                        ) {
                          Common.showToast(
                            `Discount value cannot be greater than ${IntMax}`
                          );
                          formikProps.setFieldValue("discountValue", "");
                        } else {
                          formikProps.setFieldValue("discountValue", value);
                        }
                      }}
                    />
                  </div>

                  <div className="flex flex-col col-span-2 gap-2">
                    <FormikInput
                      formikProps={formikProps}
                      name={"minOrderAmount"}
                      placeholder={"Enter Min Order Amount"}
                      label={"Min Order Amount"}
                      type={"number"}
                      max={IntMax}
                      min={IntMinLevel}
                      onChange={(value) => {
                        if (value < IntMinLevel && value != "") {
                          formikProps.setFieldValue(
                            "minOrderAmount",
                            IntMinLevel
                          );
                        } else if (value > IntMax) {
                          Common.showToast(
                            `Min Order Amount value cannot be greater than ${IntMax}`
                          );
                          formikProps.setFieldValue("minOrderAmount", "");
                        } else {
                          formikProps.setFieldValue("minOrderAmount", value);
                        }
                      }}
                    />
                  </div>

                  <div className="flex flex-col col-span-2 gap-2">
                    <FormikInput
                      formikProps={formikProps}
                      name={"maxDiscount"}
                      placeholder={"Enter Max Discount "}
                      label={"Max Discount"}
                      type={"number"}
                      max={IntMax}
                      min={IntMinLevel}
                      onChange={(value) => {
                        if (value < IntMinLevel && value != "") {
                          formikProps.setFieldValue("maxDiscount", IntMinLevel);
                        } else if (value > IntMax) {
                          Common.showToast(
                            `Max Discount cannot be greater than ${IntMax}`
                          );
                          formikProps.setFieldValue("maxDiscount", "");
                        } else {
                          formikProps.setFieldValue("maxDiscount", value);
                        }
                      }}
                    />
                  </div>

                  <div className="flex flex-col col-span-2 gap-2">
                    <FormikInput
                      formikProps={formikProps}
                      name={"transactionallowedperday"}
                      placeholder={"Enter Daily Limit "}
                      label={"Daily Transaction Limit"}
                      type={"number"}
                      max={IntMax}
                      min={IntMinLevel}
                      onChange={(value) => {
                        if (value < IntMinLevel && value != "") {
                          formikProps.setFieldValue(
                            "transactionallowedperday",
                            IntMinLevel
                          );
                        } else if (value > IntMax) {
                          Common.showToast(
                            `Daily Transaction Limit cannot be greater than ${IntMax}`
                          );
                          formikProps.setFieldValue(
                            "transactionallowedperday",
                            ""
                          );
                        } else {
                          formikProps.setFieldValue(
                            "transactionallowedperday",
                            value
                          );
                        }
                      }}
                    />
                  </div>

                  {/* Club Percentage */}
                  <div className="flex flex-col col-span-2 gap-2">
                    <FormikInput
                      formikProps={formikProps}
                      name="clubbearingpercent"
                      label="Club Percentage"
                      type="text"
                      maxLength={5}
                      placeholder="Club Percentage"
                      onChange={(value) => 
                        handlePercentageChange(value, formikProps, "clubbearingpercent", "bankbearingpercent")
                      }
                      onBlur={(e) => 
                        handlePercentageBlur(e, formikProps, "clubbearingpercent", "bankbearingpercent")
                      }
                    />
                  </div>

                  {/* Bank Percentage */}
                  <div className="flex flex-col col-span-2 gap-2">
                    <FormikInput
                      formikProps={formikProps}
                      name="bankbearingpercent"
                      label="Bank Percentage"
                      type="text"
                      maxLength={5}
                      placeholder="Bank Percentage"
                      onChange={(value) => 
                        handlePercentageChange(value, formikProps, "bankbearingpercent", "clubbearingpercent")
                      }
                      onBlur={(e) => 
                        handlePercentageBlur(e, formikProps, "bankbearingpercent", "clubbearingpercent")
                      }
                    />
                  </div>

                  <div className="flex flex-col col-span-2 gap-2">
                    <FormikSwitch
                      formikProps={formikProps}
                      name={"isactive"}
                      label={"Is Active"}
                      style={{ marginTop: "7px" }}
                    />
                  </div>

                  <div className="flex flex-col col-span-2 gap-1">
                    <FormikSwitch
                      formikProps={formikProps}
                      name={"isdisplayonapp"}
                      label={"Display on App"}
                      style={{ marginTop: "7px" }}
                      // disabled={true}
                    />
                  </div>
                </div>
              </Card>
            </div>

            <div className="flex flex-col items-end mt-5">
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  formikProps.handleSubmit();
                }}
                disabled={formikProps.isSubmitting}
                type="submit"
                className="btn-sm"
              >
                {formikProps.isSubmitting ? "Saving..." : "Save"}
              </Button>
            </div>
          </>
        );
      }}
    </Formik>
  );
}
